var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v("تنظیمات عمومی")]),_c('BaseText',{staticClass:"mb-2",attrs:{"title":"نام بورد","value":_vm.boardName,"inputType":"text","placeholder":"عنوان","maxlength":30,"showError":_vm.showError,"errortext":"نام بورد الزامیست","required":""},on:{"input":function($event){_vm.boardName = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }